'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class, _class2, _temp2;

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _PriceBar = require('./PriceBar.scss');

var _PriceBar2 = _interopRequireDefault(_PriceBar);

var _reactIntl = require('react-intl');

var _reactRedux = require('react-redux');

var _helpers = require('utils/helpers');

var _price = require('utils/price');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  Price: {
    displayName: 'Price'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/TripDetail/Price.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

var Price = _wrapComponent('Price')((_dec = (0, _reactRedux.connect)(function (state) {
  return {
    sessionData: state.session.data,
    rates: state.info.exchangeRates,
    siteConfigs: state.info.siteConfigs
  };
}, {}), _dec2 = (0, _reactCssModules2.default)(_PriceBar2.default), _dec(_class = _dec2(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Price, _Component);

  function Price() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Price);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Price.__proto__ || (0, _getPrototypeOf2.default)(Price)).call.apply(_ref, [this].concat(args))), _this), _this.getQuantity = function () {
      var _this$props = _this.props,
          trip = _this$props.trip,
          sessionData = _this$props.sessionData;

      if (trip.is_per_day !== true) {
        return sessionData.quantity > trip.max_travelers ? trip.max_travelers : sessionData.quantity;
      }
      return sessionData.quantity > trip.max_day ? trip.max_day : sessionData.quantity;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Price, [{
    key: 'render',
    value: function render() {
      var currency = this.props.sessionData.currency;
      var _props = this.props,
          trip = _props.trip,
          rates = _props.rates,
          siteConfigs = _props.siteConfigs;

      var quantity = this.getQuantity();
      var isUsedForeignPrices = trip.foreign_full_prices !== undefined && trip.foreign_full_prices[currency] !== undefined;
      var prices = isUsedForeignPrices ? trip.foreign_full_prices[currency] : trip.full_prices;
      var displayPrice = (0, _helpers.getDisplayPrice)(quantity, prices, true);
      displayPrice = isUsedForeignPrices ? displayPrice : (0, _price.convertUnit)(trip.lx_currency, 'THB', displayPrice, rates);
      return _react3.default.createElement(
        'div',
        { styleName: 'mobile-price' },
        _react3.default.createElement(
          'span',
          { styleName: 'mobile-sale-price' },
          (0, _helpers.commaizeInt)((0, _price.ceil)(isUsedForeignPrices ? displayPrice : (0, _price.convertUnit)(trip.lx_currency, 'THB', displayPrice, rates), currency, rates, !isUsedForeignPrices)),
          ' ',
          siteConfigs.fixYuan ? '元' : currency,
          '/',
          trip.is_per_day === true ? _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.head.day' }) : _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.head.person' })
        )
      );
    }
  }]);
  return Price;
}(_react2.Component), _class2.propTypes = {
  trip: _react2.PropTypes.object,
  sessionData: _react2.PropTypes.object,
  rates: _react2.PropTypes.object,
  siteConfigs: _react2.PropTypes.object
}, _temp2)) || _class) || _class));

exports.default = Price;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TripDetail/Price.js
// module id = 675
// module chunks = 47